<template>
  <Modal
    data-testid="fixed-income-transparency-modal"
    :is-open="isOpen"
    size="md"
    @close="$emit('close')"
  >
    <div class="transparency-modal">
      <div class="transparency-modal__header">
        <Heading :level="3">Transparência ao investir</Heading>
        <BaseText size="sm" :color="NebraskaColors.elementSecondary">
          Nos ativos de Renda Fixa, a remuneração por intermediação já está
          incluída - e você não paga nada mais além disso. Sem surpresas ou
          taxas extras, só clareza para investir.
        </BaseText>
      </div>

      <div class="transparency-modal__picture">
        <img
          class="transparency-modal__image"
          :src="imageSrc"
          alt="Transparência ao investir"
        />
      </div>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary label="Entendi" @click="$emit('close')" />
        </template>
      </ButtonContainer>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  Heading,
  Modal
} from '@warrenbrasil/nebraska-web';
import { computed } from 'vue';
import { useDashStore } from '@/modules/common/store/DashModule';

defineProps<{ isOpen: boolean }>();

const theme = useDashStore();

const imageSrc = computed(() =>
  theme.isDarkMode
    ? 'https://warren.com.br/assets/catalog/mockup_dark.png'
    : 'https://warren.com.br/assets/catalog/mockup_light.png'
);
</script>

<style scoped lang="less">
:deep(.base-modal--wrapper) {
  max-width: 592px !important;
}

:deep(.modal-content) {
  padding: 0;
}

.transparency-modal {
  text-align: start;

  &__header {
    margin: 0 @size-spacing-x1000 @size-spacing-x500 @size-spacing-x1000;
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x300;
  }

  &__picture {
    padding-top: @size-spacing-x600;
    background-color: @background-tertiary;
    overflow: hidden;
    height: 280px;
  }

  &__image {
    display: block;
    width: 100%;
    max-width: 260px;
    margin: 0 auto;
  }
}
</style>
